<script setup lang="ts">
import { cva } from "class-variance-authority";
import type { HTMLAttributes } from "vue";
import type { ClassProps } from "../../lib/base-props";
import { cn } from "../../lib/utils";

interface Props extends ClassProps, /* @vue-ignore */ HTMLAttributes {
	vertical?: boolean;
}

const props = defineProps<Props>();

const dividerCls = cva("divider after:bg-border before:bg-border", {
	variants: {
		vertical: {
			false: null,
			true: "divider-horizontal",
		},
	},
});
</script>

<template>
	<div :class="cn(dividerCls(props))"></div>
</template>
